import React from 'react';
import { FormFieldWrapper, Icon } from '@plone/volto/components';
import { Button } from 'semantic-ui-react';
import clearSVG from '@plone/volto/icons/clear.svg';
import { useDebounce } from 'use-debounce';

const ColorPicker = (props) => {
  const { id, value, onChange } = props;
  const colorInputRef = React.useRef(null);

  const [localColor, setLocalColor] = React.useState(value || '');
  const [debouncedColor] = useDebounce(localColor, 250);

  React.useEffect(() => {
    if (debouncedColor !== value) {
      onChange(id, debouncedColor);
    }
  }, [debouncedColor, id, onChange]);

  const handleColorChange = (event) => {
    setLocalColor(event.target.value);
  };

  return (
    <FormFieldWrapper
      {...props}
      draggable={false}
      className="simple-color-picker-widget"
    >
      <div className="wrapper" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {/* Hidden native color picker */}
        <input
          ref={colorInputRef}
          type="color"
          value={localColor || '#000000'}
          onChange={handleColorChange}
          style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
        />

        <Button.Group>
          <div
            style={{
              backgroundColor: localColor || 'white',
              width: '30px',
              height: '30px',
              cursor: 'pointer',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
            onClick={() => colorInputRef.current?.click()}
            title="Pick color"
          />

          {/* Clear button */}
          <div
            compact="true"
            style={{
              paddingLeft: '8px',
              paddingRight: '0px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setLocalColor('');
              onChange(id, null);
            }}
            title="Clear color"
          >
            <Icon name={clearSVG} size="18px" color="red" />
          </div>
        </Button.Group>

        {/* Optional label */}
        {!localColor && <span style={{ color: '#888' }}>No color selected</span>}
      </div>
    </FormFieldWrapper>
  );
};

export default ColorPicker;
